import { ChevronRight } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import type { SettingsSection } from "./settings-types";

export type SettingsNavItem = {
  id: SettingsSection;
  label: string;
  description: string;
  status: string;
  icon: LucideIcon;
};

type SettingsNavProps = {
  activeSection: SettingsSection;
  sections: SettingsNavItem[];
  onSelect: (section: SettingsSection) => void;
};

export function SettingsNav({
  activeSection,
  sections,
  onSelect,
}: SettingsNavProps) {
  return (
    <nav
      aria-label="Settings sections"
      className="border-b bg-muted/30 p-2 lg:border-b-0 lg:border-r"
    >
      {sections.map((section) => {
        const Icon = section.icon;
        const isActive = activeSection === section.id;
        return (
          <button
            key={section.id}
            type="button"
            onClick={() => onSelect(section.id)}
            className={`mb-1 flex min-h-14 w-full cursor-pointer items-center justify-between gap-2 rounded-lg px-3 text-left text-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${
              isActive
                ? "bg-background font-medium shadow-sm"
                : "text-muted-foreground hover:bg-background"
            }`}
            aria-current={isActive ? "page" : undefined}
          >
            <span className="flex min-w-0 items-center gap-2">
              <Icon className="h-4 w-4 shrink-0" />
              <span className="min-w-0">
                <span className="block truncate">{section.label}</span>
                <span className="block truncate text-xs font-normal">
                  {section.status}
                </span>
              </span>
            </span>
            {isActive ? <ChevronRight className="h-4 w-4 shrink-0" /> : null}
          </button>
        );
      })}
    </nav>
  );
}
